import React from "react";
import { withStyles } from "@material-ui/core/styles";
import { Menu, MenuProps, MenuItem } from "@material-ui/core";
import { tesaBlue } from "../../styles/colors";

export const StyledMenu = withStyles((theme) => ({
  list: {
    border: "none",
  },
  paper: {
    backgroundColor: theme.palette.primary.main,
    "& .MuiListItemIcon-root, & .MuiListItemText-primary": {
      color: theme.palette.common.white,
    },
    "& .MuiButtonBase-root, & .MuiMenuItem-root-primary": {
      backgroundColor: [theme.palette.primary.main, "!important"].join(" "),
      "&:hover": {
        backgroundColor: [tesaBlue, "!important"].join(" "),
      },
    },
  },
}))((props: MenuProps) => (
  <Menu
    elevation={0}
    getContentAnchorEl={null}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "center",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "center",
    }}
    {...props}
  />
));

export const StyledMenuItem = withStyles((theme) => ({
  root: {
    "&:focus": {
      backgroundColor: tesaBlue,
      "& .MuiListItemIcon-root, & .MuiListItemText-primary": {
        color: theme.palette.common.white,
      },
    },
  },
}))(MenuItem);
